import * as jQuery from 'jquery';
var $ = jQuery;
export function storiesWidgetScripts() {
    $(document).ready(function () {
    });
}
